module.exports = __webpack_public_path__ + "img/line.3a35ffb1.svg";